import * as React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';

import { SkillIcon } from '../icons';
import urls from '../../app/urls';

const useStyles = makeStyles(theme => ({
    root: {
        marginBottom: theme.spacing(2),
        display: 'flex',
        alignItems: 'center',
    },
    mainIcon: {
        marginRight: theme.spacing(1),
        fontSize: theme.sizes.largeIcon,

        [theme.breakpoints.only('sm')]: {
            display: 'none',
        },
    },
    text: {
        fontSize: theme.sizes.reducedH5FontSize,
    },
}));

const SkillLink = ({ skill, studentCode }) => {
    const classes = useStyles();

    if (!skill?.module) {
        return null;
    }

    return (
        <Link
            className={classes.root}
            to={studentCode ? `${urls.studentCode.home}/${studentCode}/${urls.studentCode.parts.skill}/${skill.module.id}` : `${urls.inside.program.skill}/${skill.module.id}`}
        >
            <SkillIcon className={classes.mainIcon} color="secondary" />
            <Typography variant="h5" className={classes.text}>{skill.module.name}</Typography>
        </Link>
    );
};

SkillLink.propTypes = {
    skill: PropTypes.object.isRequired,
    studentCode: PropTypes.string,
};

SkillLink.defaultProps = {
    studentCode: null,
};

export default SkillLink;
